import dev from './dev';
import prod from './prod';

const environmentResolver = () => {
    let stageName = '';
    return process.env.NODE_ENV === 'development' || stageName === 'developmentStaging' ? dev : prod;
};

export const ENV = environmentResolver();